'use client'

import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import MUIStack from '@mui/material/Stack'
import { MatterList } from '@repo/ui/MatterList'
import { useLoadingStore } from '@repo/store/useLoadingStore'
import { useMattersStore } from '@repo/store/useMattersStore'

export const MatterDrawerRelatedMattersTab = ({ workspaceDetailCardVisible }: MatterDrawerRelatedMattersTabProps) => {
  const { isLoading } = useLoadingStore()
  const [isProcessing, setIsProcessing] = useState(false)
  const [results, setResults] = useState<any>(null)
  const {
    currentMatter,
    fetchMatterByClientNo,
    relatedMatters,
    matterDrawerIsOpen,
    setMatterDrawerIsOpen,
    matterDrawerClientNo,
    matterDrawerClientMatterNo
  } = useMattersStore()
  const { clientMatterNo } = currentMatter || {}

  useEffect(() => {
    const getData = async (matterDrawIsVisible?: boolean) => {
      try {
        setIsProcessing(true)
        await fetchMatterByClientNo({ clientNo: matterDrawIsVisible ? matterDrawerClientNo : currentMatter.clientNo })
      } catch (err) {
        setResults(null)
      } finally {
        setIsProcessing(false)
      }
    }

    if (matterDrawerIsOpen && matterDrawerClientNo) getData(matterDrawerIsOpen)
    if (workspaceDetailCardVisible && clientMatterNo && !matterDrawerIsOpen) getData()
  }, [workspaceDetailCardVisible, matterDrawerClientNo, fetchMatterByClientNo, matterDrawerIsOpen])

  useEffect(() => {
    if (!matterDrawerIsOpen || !matterDrawerClientNo || !relatedMatters?.length) setResults(null)
    if (matterDrawerIsOpen && matterDrawerClientNo && relatedMatters?.length) {
      // don't show the current matter
      const results = relatedMatters.filter(
        ({ clientNo, matterNo }: any) => `${clientNo}-${matterNo}` !== matterDrawerClientMatterNo
      )

      setResults(results)
    }
    if (workspaceDetailCardVisible && clientMatterNo && relatedMatters?.length) {
      setResults(relatedMatters)
    }
  }, [
    matterDrawerClientNo,
    relatedMatters,
    matterDrawerClientMatterNo,
    matterDrawerIsOpen,
    workspaceDetailCardVisible,
    clientMatterNo
  ])

  return (
    <MUIStack
      data-testid="MatterDrawerRelatedMattersTab"
      role="tabpanel"
      direction="column"
      gap={5}
      sx={{ padding: '14px 12px', width: '100%' }}
    >
      <MatterList
        matters={results}
        isLoading={isLoading || isProcessing}
        clickHandler={() => setMatterDrawerIsOpen(false)}
        isEmpty={!results?.length}
        maxHeight="100%"
      />
    </MUIStack>
  )
}

type MatterDrawerRelatedMattersTabProps = {
  workspaceDetailCardVisible: boolean
}

MatterDrawerRelatedMattersTab.propTypes = {
  workspaceDetailCardVisible: PropTypes.bool
}
